<template>
  <div class="main">
    <p class="smallTitle">{{ categoryJp }}</p>
    <p class="subtitle" v-html="categoryEn"></p>
    <iframe
      class="iframe"
      :src="this.iframeUrl"
      style="width: 100%; height: 600px; border: 0px none"
      frameborder="0"
      allowfullscreen
      v-if="!this.tbFlag"
    ></iframe>
    <div v-html="this.dbHtmlCode" v-if="this.tbFlag" class="iframe"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      categoryJp: "",
      iframeUrl: "",
      dbKinds: "",
      dbHtmlCode: "",
      vizId: "",
      tbFlag: false,
    };
  },
  props: ["categoryEn"],
  mounted() {
    window.scrollTo(0, 0);
    var now = new Date();
    fetch("../json/dashboardDataList.json"+"?"+now.getTime())
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        var item = data.find(
          ({ categoryEn }) => categoryEn === this.categoryEn
        );
        if (item == undefined) {
          this.$router.push({ name: 'NotFound' });
        }
        this.categoryJp = item.name;
        if (item.dbKinds == "tb") {
          this.tbFlag = true;
          this.dbHtmlCode = item.dbHtmlCode;
          this.vizId = item.vizId;

          this.$nextTick(function () {
            var divElement = document.getElementById(this.vizId);
            var vizElement = divElement.getElementsByTagName("object")[0];
            vizElement.style.width = "100%";
            vizElement.style.height = divElement.offsetWidth * 0.75 + "px";
            var scriptElement = document.createElement("script");
            scriptElement.src =
              "https://public.tableau.com/javascripts/api/viz_v1.js";
            vizElement.parentNode.insertBefore(scriptElement, vizElement);
          });
        } else {
          this.iframeUrl = item.iframeUrl;
        }
      });
  },
};
</script>

<style scoped>
.main {
  width: 80%;
  margin-top: 100px;
  display: flex;
  flex-direction: column;
}

.smallTitle {
  font-size: 2.5vw;
  font-weight: 800;
  color: #072a40;
  position: relative;
}

.subtitle {
  font-size: 1.5vw;
  font-weight: 800;
  color: #d9b97e;
  margin-bottom: 40px;
}

.iframe {
  margin-bottom: 100px;
}
</style>
